import React from 'react'
//import * as slideLayoutJSON from '../slideLayout/slideLayoutDefinition.json'

class SlideWrapper extends React.PureComponent{

	render(){	
		const {displayWidth, isStatic, template, reportView}=this.props
		const slideWidth = 1280
		const scale=displayWidth/slideWidth

		const slideLayoutCalcCSS = {
			transform: `scale(${scale})`,
			transformOrigin: 'top left'
		}
	
		return(
			<div style={slideLayoutCalcCSS} translate="no" className={'slide notranslate ' + (isStatic ? ' slide--static' : ' slide--form') + (template ? ` template--${template}` : ' template--none') + (reportView ? ' slide--reportView' : '')}>
				{this.props.children}			 	
			</div>
		)		
	}	
}


export default SlideWrapper





// WEBPACK FOOTER //
// ./src/components/slides/slideWrappers/SlideWrapper.js